export const ROUTE_PATHS = {
  HOME: '/',
  PRODUCTS: '/products',
  PRODUCT_FKM: '/products/fkm',
  PRODUCT_EPDM: '/products/epdm',
  PRODUCT_NBR: '/products/nbr',
  PRODUCT_NR: '/products/nr',
  PRODUCT_ESD: '/products/esd',
  PRODUCT_CR: '/products/cr',
  TECH_SPECS: '/tech-specs',
  CAPABILITIES: '/capabilities',
  INDUSTRIES: '/industries',
  SELECTION: '/selection',
  ABOUT: '/about',
  CONTACT: '/contact',
  GUIDE: '/guide',
  // 管理后台
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_BOM: '/admin/bom',
  ADMIN_ORDERS: '/admin/orders',
  ADMIN_PRODUCTION: '/admin/production',
  ADMIN_LOGISTICS: '/admin/logistics',
  ADMIN_OVERVIEW: '/admin/overview',
} as const;

export interface Product {
  id: string;
  name: string;
  nameEn: string;
  code: string;
  tempRange: string;
  tensile: string;
  elongation: string;
  hardness: string;
  color: string;
  thickness: string;
  description: string;
  applications: string[];
  keyAdvantages: string[];
}

export interface Industry {
  id: string;
  name: string;
  nameEn: string;
  icon: string;
  description: string;
}

export interface CompanyStat {
  id: string;
  value: string;
  label: string;
  labelEn: string;
}

export interface SelectionMatrixRow {
  id: string;
  productName: string;
  productCode: string;
  tempRange: string;
  tensile: string;
  elongation: string;
  hardness: string;
  keyFeature: string;
}

export const PRODUCTS: Product[] = [
  {
    id: 'fkm',
    name: 'FKM氟橡胶板',
    nameEn: 'FKM Fluoroelastomer Sheet',
    code: 'FKM',
    tempRange: '-30°C ~ +220°C',
    tensile: '≥10.0 MPa',
    elongation: '≥150%',
    hardness: '60-90 Shore A',
    color: '黑色/棕色',
    thickness: '1.0-20.0mm',
    description: '耐强腐蚀、耐高温、耐油性能卓越的高端密封材料',
    applications: [
      '化工石化管道密封',
      '航空航天燃油系统',
      '汽车发动机密封件',
      '高温工业设备',
      '强腐蚀性介质环境'
    ],
    keyAdvantages: [
      '优异的耐化学腐蚀性',
      '宽温度范围适应性',
      '长期耐老化性能',
      '低压缩永久变形'
    ]
  },
  {
    id: 'epdm',
    name: 'EPDM三元乙丙橡胶板',
    nameEn: 'EPDM Rubber Sheet',
    code: 'EPDM',
    tempRange: '-40°C ~ +150°C',
    tensile: '≥8.0 MPa',
    elongation: '≥300%',
    hardness: '50-80 Shore A',
    color: '黑色/彩色',
    thickness: '1.0-20.0mm',
    description: '耐候抗UV、绝缘性能优异的户外建筑专用材料',
    applications: [
      '建筑幕墙密封',
      '屋面防水系统',
      '电力绝缘垫',
      '户外设备防护',
      '水处理设施'
    ],
    keyAdvantages: [
      '卓越的耐候性',
      '优异的电绝缘性',
      '抗臭氧老化',
      '环保无毒'
    ]
  },
  {
    id: 'nbr',
    name: 'NBR丁腈橡胶板',
    nameEn: 'NBR Nitrile Rubber Sheet',
    code: 'NBR',
    tempRange: '-30°C ~ +100°C',
    tensile: '≥12.0 MPa',
    elongation: '≥350%',
    hardness: '60-80 Shore A',
    color: '黑色',
    thickness: '1.0-20.0mm',
    description: '耐石油基油脂、机械强度高的工业密封首选',
    applications: [
      '液压系统密封',
      '机械设备垫片',
      '油田开采设备',
      '汽车传动系统',
      '石油储运设施'
    ],
    keyAdvantages: [
      '优异的耐油性',
      '高机械强度',
      '良好的耐磨性',
      '性价比高'
    ]
  },
  {
    id: 'nr',
    name: 'NR天然橡胶板（高耐磨配方）',
    nameEn: 'NR Natural Rubber Sheet',
    code: 'NR',
    tempRange: '-50°C ~ +80°C',
    tensile: '≥18.0 MPa',
    elongation: '≥500%',
    hardness: '50-70 Shore A',
    color: '黑色/米色',
    thickness: '2.0-20.0mm',
    description: '高弹减震、超强耐磨的矿山物料输送专用材料',
    applications: [
      '矿山输送带衬板',
      '物料溜槽衬里',
      '减震缓冲垫',
      '港口码头防护',
      '重型机械底座'
    ],
    keyAdvantages: [
      '极高的弹性',
      '卓越的耐磨性',
      '优异的减震性能',
      '天然环保'
    ]
  },
  {
    id: 'cr',
    name: 'CR氯丁橡胶板',
    nameEn: 'CR Neoprene Rubber Sheet',
    code: 'CR',
    tempRange: '-35°C ~ +100°C',
    tensile: '≥10.0 MPa',
    elongation: '≥300%',
    hardness: '55-75 Shore A',
    color: '黑色',
    thickness: '1.0-20.0mm',
    description: '固有阻燃、耐候性好的船舶建筑安全材料',
    applications: [
      '船舶舱室密封',
      '建筑防火隔断',
      '电缆保护套',
      '桥梁支座垫',
      '海洋工程设施'
    ],
    keyAdvantages: [
      '固有阻燃性',
      '良好的耐候性',
      '优异的粘接性',
      '耐海水腐蚀'
    ]
  },
  {
    id: 'antistatic',
    name: '抗静电橡胶板',
    nameEn: 'Antistatic Rubber Sheet',
    code: 'ESD',
    tempRange: '-20°C ~ +70°C',
    tensile: '≥6.0 MPa',
    elongation: '≥200%',
    hardness: '60-75 Shore A',
    color: '黑色/绿色',
    thickness: '2.0-10.0mm',
    description: '表面电阻稳定、防静电泄放的电子半导体专用材料',
    applications: [
      '电子厂房地面',
      '半导体工作台',
      '精密仪器垫',
      '洁净室铺装',
      '防爆区域地面'
    ],
    keyAdvantages: [
      '稳定的防静电性能',
      '表面电阻可控',
      '耐磨耐用',
      '符合ESD标准'
    ]
  }
];

export const INDUSTRIES: Industry[] = [
  {
    id: 'chemical',
    name: '化工石化',
    nameEn: 'Chemical & Petrochemical',
    icon: 'Factory',
    description: '管道密封、储罐衬里、腐蚀性介质防护'
  },
  {
    id: 'construction',
    name: '建筑幕墙',
    nameEn: 'Construction & Curtain Wall',
    icon: 'Building2',
    description: '幕墙密封、屋面防水、桥梁支座'
  },
  {
    id: 'automotive',
    name: '汽车轨道交通',
    nameEn: 'Automotive & Rail Transit',
    icon: 'Car',
    description: '发动机密封、传动系统、车厢减震'
  },
  {
    id: 'mining',
    name: '矿山采掘',
    nameEn: 'Mining & Quarrying',
    icon: 'Pickaxe',
    description: '输送带衬板、溜槽衬里、耐磨防护'
  },
  {
    id: 'power',
    name: '电力能源',
    nameEn: 'Power & Energy',
    icon: 'Zap',
    description: '绝缘垫、电缆保护、变电站设施'
  },
  {
    id: 'electronics',
    name: '电子半导体',
    nameEn: 'Electronics & Semiconductor',
    icon: 'Cpu',
    description: '防静电地面、洁净室、精密仪器垫'
  },
  {
    id: 'food',
    name: '食品医疗',
    nameEn: 'Food & Medical',
    icon: 'Pill',
    description: 'FDA认证材料、无毒密封、卫生级应用'
  },
  {
    id: 'aerospace',
    name: '航空航天',
    nameEn: 'Aerospace & Defense',
    icon: 'Plane',
    description: '燃油系统、高温密封、特种应用'
  }
];

export const COMPANY_STATS: CompanyStat[] = [
  {
    id: 'experience',
    value: '20+',
    label: '年制造经验',
    labelEn: 'Years Experience'
  },
  {
    id: 'export',
    value: '10+',
    label: '出口国家地区',
    labelEn: 'Export Markets'
  },
  {
    id: 'certification',
    value: 'ISO 9001',
    label: '质量认证',
    labelEn: 'Quality Certified'
  },
  {
    id: 'products',
    value: '10+',
    label: '产品系列',
    labelEn: 'Product Lines'
  }
];

export const SELECTION_MATRIX: SelectionMatrixRow[] = [
  {
    id: 'fkm-standard',
    productName: 'FKM氟橡胶板（标准型）',
    productCode: 'FKM-S',
    tempRange: '-30~+220°C',
    tensile: '≥10.0',
    elongation: '≥150',
    hardness: '70±5',
    keyFeature: '耐强酸碱'
  },
  {
    id: 'fkm-high-temp',
    productName: 'FKM氟橡胶板（高温型）',
    productCode: 'FKM-HT',
    tempRange: '-20~+250°C',
    tensile: '≥12.0',
    elongation: '≥120',
    hardness: '80±5',
    keyFeature: '超高温稳定'
  },
  {
    id: 'epdm-standard',
    productName: 'EPDM三元乙丙板（标准型）',
    productCode: 'EPDM-S',
    tempRange: '-40~+150°C',
    tensile: '≥8.0',
    elongation: '≥300',
    hardness: '65±5',
    keyFeature: '耐候抗UV'
  },
  {
    id: 'epdm-insulation',
    productName: 'EPDM三元乙丙板（绝缘型）',
    productCode: 'EPDM-I',
    tempRange: '-40~+120°C',
    tensile: '≥10.0',
    elongation: '≥250',
    hardness: '70±5',
    keyFeature: '高压绝缘'
  },
  {
    id: 'nbr-standard',
    productName: 'NBR丁腈橡胶板（标准型）',
    productCode: 'NBR-S',
    tempRange: '-30~+100°C',
    tensile: '≥12.0',
    elongation: '≥350',
    hardness: '70±5',
    keyFeature: '耐油性优'
  },
  {
    id: 'nbr-high-strength',
    productName: 'NBR丁腈橡胶板（高强型）',
    productCode: 'NBR-HS',
    tempRange: '-25~+90°C',
    tensile: '≥15.0',
    elongation: '≥300',
    hardness: '75±5',
    keyFeature: '高机械强度'
  },
  {
    id: 'nr-standard',
    productName: 'NR天然橡胶板（标准型）',
    productCode: 'NR-S',
    tempRange: '-50~+80°C',
    tensile: '≥18.0',
    elongation: '≥500',
    hardness: '60±5',
    keyFeature: '高弹性'
  },
  {
    id: 'nr-wear-resistant',
    productName: 'NR天然橡胶板（耐磨型）',
    productCode: 'NR-WR',
    tempRange: '-40~+70°C',
    tensile: '≥20.0',
    elongation: '≥450',
    hardness: '65±5',
    keyFeature: '超强耐磨'
  },
  {
    id: 'cr-standard',
    productName: 'CR氯丁橡胶板（标准型）',
    productCode: 'CR-S',
    tempRange: '-35~+100°C',
    tensile: '≥10.0',
    elongation: '≥300',
    hardness: '65±5',
    keyFeature: '固有阻燃'
  },
  {
    id: 'cr-marine',
    productName: 'CR氯丁橡胶板（船用型）',
    productCode: 'CR-M',
    tempRange: '-30~+90°C',
    tensile: '≥12.0',
    elongation: '≥280',
    hardness: '70±5',
    keyFeature: '耐海水'
  },
  {
    id: 'esd-standard',
    productName: '抗静电橡胶板（标准型）',
    productCode: 'ESD-S',
    tempRange: '-20~+70°C',
    tensile: '≥6.0',
    elongation: '≥200',
    hardness: '65±5',
    keyFeature: '表面电阻10⁶-10⁹Ω'
  },
  {
    id: 'esd-conductive',
    productName: '抗静电橡胶板（导电型）',
    productCode: 'ESD-C',
    tempRange: '-20~+60°C',
    tensile: '≥5.0',
    elongation: '≥180',
    hardness: '70±5',
    keyFeature: '表面电阻10³-10⁶Ω'
  },
  {
    id: 'fabric-reinforced',
    productName: '加布橡胶板（织物增强）',
    productCode: 'FR-NR',
    tempRange: '-40~+80°C',
    tensile: '≥25.0',
    elongation: '≥400',
    hardness: '65±5',
    keyFeature: '高撕裂强度'
  }
];

export const NAV_LINKS = [
  { id: 'home',         label: '首页',   labelEn: 'HOME',         href: '/' },
  { id: 'products',     label: '产品系列', labelEn: 'PRODUCTS',     href: '/products' },
  { id: 'capabilities', label: '制造能力', labelEn: 'CAPABILITIES', href: '/capabilities' },
  { id: 'industries',   label: '应用行业', labelEn: 'INDUSTRIES',   href: '/industries' },
  { id: 'guide',        label: '选材指南', labelEn: 'GUIDE',        href: '/guide' },
  { id: 'selection',    label: '选型矩阵', labelEn: 'SELECTION',    href: '/selection' },
  { id: 'about',        label: '关于我们', labelEn: 'ABOUT US',     href: '/about' },
  { id: 'contact',      label: '联系我们', labelEn: 'CONTACT',      href: '/contact' },
];